module.exports = __webpack_public_path__ + "static/media/video.6a5be112.svg";